<script lang="ts" setup>
const props = defineProps({
  rotate: {
    type: Boolean,
  },
});
</script>

<template>
  <i
    class="ui-chevron far fa-angle-up"
    :class="{
      'ui-chevron_rotate': rotate,
    }"
  />
</template>

<style lang="scss">
.ui-chevron {
  transition: transform .3s;
  transform: rotateZ(0deg);
  &_rotate {
    transform: rotateZ(-180deg);
  }
}
</style>
